import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "heart-empty",
  "use": "heart-empty-usage",
  "viewBox": "0 0 19 17.209",
  "content": "<symbol viewBox=\"0 0 19 17.209\" id=\"heart-empty\"><path d=\"M9.5 17.209l-.354-.356a182.07 182.07 0 0 0-3.01-2.941C2.441 10.36 0 8.015 0 5c0-2.851 2.149-5 5-5 1.785 0 3.539.978 4.5 2.423C10.461.978 12.214 0 14 0c2.852 0 5 2.149 5 5 0 3.015-2.44 5.36-6.136 8.911-.929.894-1.939 1.864-3.01 2.941l-.354.357zM5 1C2.72 1 1 2.72 1 5c0 2.589 2.319 4.817 5.829 8.19.831.799 1.726 1.66 2.671 2.602.945-.942 1.839-1.803 2.671-2.602C15.681 9.817 18 7.589 18 5c0-2.28-1.72-4-4-4-1.735 0-3.433 1.127-4.034 2.68L9.5 4.886 9.034 3.68C8.433 2.127 6.736 1 5 1\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/heart-empty.svg
// module id = 167
// module chunks = 0